import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CheckCircleIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingOffer() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  const features = [<>
      <b data-id="element-101">+7.000 patrones</b> en PDF descargable al instante
    </>, <>
      <b data-id="element-102">6 bonos exclusivos</b> valorados en $127.000 ARS (incluidos gratis)
    </>, <>Instrucciones paso a paso con gráficos detallados</>, <>Acceso inmediato (descarga en menos de 24 hs)</>, <>Compatible con celular, tablet y computadora</>];
  return <section className="w-full py-24 px-4 bg-gradient-to-b from-cream to-secondary/30 relative overflow-hidden" data-id="element-103">
      {/* Decorative blobs */}
      <div className="absolute top-20 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-x-1/2" data-id="element-104"></div>
      <div className="absolute bottom-20 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl translate-x-1/2" data-id="element-105"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-106">
        {/* Badge */}
        <div className="text-center mb-8" data-id="element-107">
          <span className="inline-block bg-accent text-white font-body font-bold px-6 py-2 rounded-full text-sm md:text-base shadow-sm tracking-wide" data-id="element-108">
            🔥 +2000 descargas
          </span>
        </div>

        {/* Main Offer Card */}
        <div className="bg-white rounded-[2.5rem] shadow-soft-lg overflow-hidden border border-secondary/50 relative" data-id="element-109">
          {/* Top accent bar */}
          <div className="h-2 w-full bg-gradient-to-r from-primary via-accent to-primary" data-id="element-110"></div>

          <div className="p-8 md:p-14" data-id="element-111">
            <div className="text-center mb-10" data-id="element-112">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-textDark mb-4" data-id="element-113">
                CREA CON HILOS
              </h2>
              <p className="font-body text-xl text-primary font-semibold" data-id="element-114">
                7.000 PATRONES + 6 BONOS
              </p>
            </div>

            {/* Pricing */}
            <div className="mb-12 bg-secondary/20 rounded-3xl p-8 border border-secondary/50" data-id="element-115">
              <PriceDisplay originalPrice={35000} salePrice={17999} currency="ARS" data-id="element-116" />
            </div>

            {/* CTA Button */}
            <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="block w-full bg-primary hover:bg-primary/90 text-white font-body font-bold text-xl py-6 rounded-full shadow-soft-lg text-center transition-all duration-300 transform hover:-translate-y-1 mb-12" data-id="element-117">
              COMPRAR AHORA
            </a>

            {/* What's Included */}
            <div className="space-y-5 mb-12" data-id="element-118">
              {features.map((feature, index) => <div key={index} className="flex items-start gap-4" data-id="element-119">
                  <div className="bg-success/10 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-120">
                    <CheckCircleIcon className="w-5 h-5 text-success" aria-hidden="true" data-id="element-121" />
                  </div>
                  <p className="font-body text-lg text-textDark leading-relaxed" data-id="element-122">
                    {feature}
                  </p>
                </div>)}
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center items-center gap-8 pt-8 border-t border-secondary/50" data-id="element-123">
              <div className="flex items-center gap-2 text-textLight" data-id="element-124">
                <ShieldCheckIcon className="w-6 h-6 text-success" aria-hidden="true" data-id="element-125" />
                <span className="font-body text-sm font-medium" data-id="element-126">
                  Compra Segura
                </span>
              </div>
              <div className="flex items-center gap-2 text-textLight" data-id="element-127">
                <CreditCardIcon className="w-6 h-6 text-success" aria-hidden="true" data-id="element-128" />
                <span className="font-body text-sm font-medium" data-id="element-129">
                  Pago Protegido
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="mt-10 bg-white border border-secondary rounded-3xl p-8 text-center shadow-soft flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-130">
          <div className="text-5xl" data-id="element-131">🛡️</div>
          <div className="text-left" data-id="element-132">
            <p className="font-heading font-bold text-2xl text-textDark mb-2" data-id="element-133">
              Probalo 7 días sin riesgo
            </p>
            <p className="font-body text-lg text-textLight" data-id="element-134">
              Si no te gusta o no es para vos, te devolvemos el 100% de tu
              dinero. <u data-id="element-135">Sin preguntas</u>.
            </p>
          </div>
        </div>
      </div>
    </section>;
}